<script>
import { nextTick } from 'vue';
export default {
  data: function () {
    return {
      items: [],
      page: 2,
      hasMore: true,
      loading: false,
    };
  },
  props: [
    'handlebarsTemplateUrl',
    'handlebarsDataUrl',
    'divClass',
    'buttonText',
    'hasMoreItems',
    'blockId',
  ],
  mounted() {
    this.Init();
    this.hasMore = this.hasMoreItems == 'True';
  },
  methods: {
    async Init() {
      var templateResponse = await fetch(this.handlebarsTemplateUrl, {
        method: 'get',
      });
      var templateText = await templateResponse.text();
      var handlebars = await import(
        /* webpackChunkName: "handlebars" */ 'handlebars'
      );
      this.handlebarsTemplate = handlebars.compile(templateText);
    },
    async loadMore() {
      try {
        this.loading = true;
        let url = this.handlebarsDataUrl + '?paging=' + this.page;
        if (this.blockId) {
          url =
            this.handlebarsDataUrl +
            '?id=' +
            this.blockId +
            '&paging=' +
            this.page;
        }
        let res = await fetch(url, {
          method: 'get',
        });
        var parsedData = await res.json();
        for (const item of parsedData.tags) {
          var markup = this.handlebarsTemplate(item);
          this.items.push({ html: markup });
          this.hasMore = parsedData.hasMore;
        }
        this.page++;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }

      await nextTick();

      let items = document.querySelectorAll('.fillMoreItem');

      if (items.length > 0) {
        let element = items[items.length - 1];

        window.scrollTo({
          top: element.offsetTop + 100,
          left: 0,
          behavior: 'smooth',
        });
      }

      return true;
    },
  },
};
</script>
<template>
  <div id="fillMoreContainer" class="row mb-md">
    <div
      class="fillMoreItem"
      :class="divClass"
      v-for="item in items"
      v-html="item.html"></div>
    <div class="col-12 text-center">
      <transition name="fade" mode="out-in">
        <div>
          <button
            v-if="hasMore"
            class="button-small"
            :disabled="loading"
            @click="loadMore">
            <span v-if="loading" class="material-icons spinning">cached</span>
            <span v-else>{{ buttonText }}</span>
          </button>
        </div>
      </transition>
    </div>
  </div>
</template>
